import { render, staticRenderFns } from "./DetailsMsg.vue?vue&type=template&id=22c684b5&scoped=true&lang=pug"
import script from "./DetailsMsg.vue?vue&type=script&lang=js"
export * from "./DetailsMsg.vue?vue&type=script&lang=js"
import style0 from "./DetailsMsg.vue?vue&type=style&index=0&id=22c684b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c684b5",
  null
  
)

export default component.exports